<template lang="html">
  <div class="">
    <slot @click="uploadFile" name="activator">
      <button :disabled="uploading" class="btn btn-info btn-fill btn-wd">{{ uploading ? `${progression}%` : 'Terminer' }}</button>
    </slot>
  </div>
</template>

<script>
import firebase from 'firebase'
import md5 from 'md5'

export default {
  props: {
    reference: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      uploading: false,
      progress: {}
    }
  },
  watch: {
    ready (ready) {
      if (ready) {
        console.log('READY')
        console.log(this.value)
        firebase.firestore().collection(this.reference).add({
          ...this.value,
          created: new Date(),
          updated: new Date(),
          deleted: false
        }).then((doc) => {
          this.$emit('success', doc)
        }).catch((err) => {
          this.$emit('error', err)
        })
      }
    }
  },
  computed: {
    ready () {
      return this.uploading && Object.values(this.progress).every((progress) => progress === 100)
    },
    progression () {
      let total = 0
      let current = 0
      for (let key in this.progress) {
        total += 100
        current += this.progress[key]
      }
      return total > 0 ? Math.floor((100 * current) / total) : 100
    }
  },
  methods: {
    upload () {
      for (let key in this.value) {
        const value = this.value[key]
        if (value instanceof File) {
          this.uploadFile(value, key)
        }
      }
      this.uploading = true
    },
    uploadFile (file, key) {
      this.$set(this.progress, key, 0)
      const metadata = {
        cacheControl: 'public,max-age=3600',
        contentType: file.type,
        customMetadata: {
          name: file.name,
          owner: firebase.auth().currentUser.uid
        }
      }
      const reader = new FileReader()
      reader.onload = e => {
        const hash = md5(e.target.result)
        const ref = `/users/${firebase.auth().currentUser.uid}/products/${hash}`
        const upload = firebase.storage()
          .ref(ref)
          .put(file, metadata)
        upload.on('state_changed', (snapshot) => {
          this.$set(this.progress, key, (snapshot.bytesTransferred / snapshot.totalBytes) * 100)
        }, (err) => {
          this.$emit('error', err)
        }, (res) => {
          this.$set(this.progress, key, 100)
          this.value[key] = {
            ref: ref,
            url: upload.snapshot.downloadURL
          }
        })
      }
      reader.readAsBinaryString(file)
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Utils/Uploader.vue